import { usePracticeLabs } from '@witmetrics/data-store';
import { PAGES } from '@/constants/pages';
import {
  CasesIcon,
  DashboardIcon,
  FilesIcon,
  OrdersIcon,
  PatientsIcon,
  ScanServicesIcon,
  TasksIcon,
} from '@/icons';
import SidebarButton from '../SidebarButton';

export type PracticeSidebarProps = {
  color?: string;
  bgColor?: string;
  iconClassName?: string;
};

export default function PracticeSidebar({
  iconClassName,
  ...props
}: PracticeSidebarProps) {
  const practiceLabs = usePracticeLabs();

  return (
    <>
      <SidebarButton
        {...props}
        href={PAGES.DASHBOARD}
        label="Dashboard"
        icon={<DashboardIcon className={iconClassName} />}
      />
      <SidebarButton
        {...props}
        href={PAGES.TASKS}
        label="Tasks"
        icon={<TasksIcon className={iconClassName} />}
      />
      <SidebarButton
        {...props}
        href={PAGES.CASES}
        label="Cases"
        icon={<CasesIcon className={iconClassName} />}
      />
      <SidebarButton
        {...props}
        href={PAGES.SCAN_SERVICES}
        label="Scan Services"
        icon={<ScanServicesIcon className={iconClassName} />}
      />
      {practiceLabs.length > 0 && (
        <SidebarButton
          {...props}
          href={PAGES.ORDERS}
          label="Orders"
          icon={<OrdersIcon className={iconClassName} />}
        />
      )}
      <SidebarButton
        {...props}
        href={PAGES.PATIENTS}
        label="Patients"
        icon={<PatientsIcon className={iconClassName} />}
      />
      <SidebarButton
        {...props}
        href={PAGES.FILES}
        label="Files"
        icon={<FilesIcon className={iconClassName} />}
      />
    </>
  );
}
